import React from 'react';

const SvgUserIdCard: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="userIdCard_svg__a">
          <path d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
      <g
        clipPath="url(#userIdCard_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx={2.25} cy={2.25} r={2.25} transform="translate(6.25 7.5)" />
        <path d="M2 18.5V5.54A2.04 2.04 0 014.041 3.5H20a2 2 0 012 2v13a2 2 0 01-2 2H4a2 2 0 01-2-2zM15 9.5h4M17.4 13.5H15" />
        <path d="M12.1 16.5a3.176 3.176 0 00-2.949-2H7.854a3.173 3.173 0 00-2.948 2" />
      </g>
    </svg>
  );
};

export default SvgUserIdCard;
